import { Component, EventEmitter, Output } from '@angular/core';
import { map, of } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../services/notifications-v2.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../basic-features/icon-v2/icon.component";
function NotificationsCountV2Component_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx_r0.counter$));
  }
}
export class NotificationsCountV2Component {
  notificationsService;
  clicked = new EventEmitter();
  counter$ = of('0');
  constructor(notificationsService) {
    this.notificationsService = notificationsService;
  }
  ngOnInit() {
    this.counter$ = this.notificationsService.unreadNotifications$.pipe(map(value => value.length), map(value => value < 100 ? value.toString() : '99+'));
  }
  static ɵfac = function NotificationsCountV2Component_Factory(t) {
    return new (t || NotificationsCountV2Component)(i0.ɵɵdirectiveInject(i1.NotificationsV2Service));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NotificationsCountV2Component,
    selectors: [["geaui-notifications-count-v2"]],
    outputs: {
      clicked: "clicked"
    },
    decls: 3,
    vars: 3,
    consts: [["file", "24px_bell", "color", "white", "colorProp", "stroke", 1, "gea-notification-bell-icon", "clickable", "bell", 3, "click"], ["class", "gea-notification-bell-counter", 4, "ngIf"], [1, "gea-notification-bell-counter"]],
    template: function NotificationsCountV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "geaui-icon-v2", 0);
        i0.ɵɵlistener("click", function NotificationsCountV2Component_Template_geaui_icon_v2_click_0_listener() {
          return ctx.clicked.emit();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(1, NotificationsCountV2Component_span_1_Template, 3, 3, "span", 1);
        i0.ɵɵpipe(2, "async");
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx.counter$) !== "0");
      }
    },
    dependencies: [i2.NgIf, i3.IconComponent, i2.AsyncPipe],
    styles: ["[_nghost-%COMP%]{position:relative}.clickable[_ngcontent-%COMP%]{cursor:pointer}.gea-notification-bell-counter[_ngcontent-%COMP%]{position:absolute;top:-5px;right:-5px;background:var(--geaui-energetic-pink);border-radius:50%;width:15px;height:15px;z-index:100;display:flex;align-items:center;justify-content:center;text-align:center;line-height:15px;font-size:10px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationsCountV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-notifications-count-v2',
      template: "<geaui-icon-v2\n  class=\"gea-notification-bell-icon clickable bell\"\n  (click)=\"clicked.emit()\"\n  file=\"24px_bell\"\n  color=\"white\"\n  colorProp=\"stroke\"></geaui-icon-v2>\n<span class=\"gea-notification-bell-counter\" *ngIf=\"(counter$ | async) !== '0'\">{{ counter$ | async }}</span>\n",
      styles: [":host{position:relative}.clickable{cursor:pointer}.gea-notification-bell-counter{position:absolute;top:-5px;right:-5px;background:var(--geaui-energetic-pink);border-radius:50%;width:15px;height:15px;z-index:100;display:flex;align-items:center;justify-content:center;text-align:center;line-height:15px;font-size:10px}\n"]
    }]
  }], () => [{
    type: i1.NotificationsV2Service
  }], {
    clicked: [{
      type: Output
    }]
  });
})();
